import _ from 'lodash';

const sleep = (time) => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(true), time);
  });
};

export function polling(fn = _.noop, wait = 3000) {
  let canceled = false;
  const exec = async () => {
    if (!canceled) {
      try {
        await fn();
      // eslint-disable-next-line no-empty
      } catch (e) {}
      await sleep(wait);
      return exec();
    }
  };
  sleep(wait).finally(exec);
  const cancel = () => canceled = true;
  return cancel;
}
